import { useMediaQuery } from './useMediaQuery';

export { useMediaQuery }
